import clsx from 'clsx';
import { FC } from 'react';

import Image from '@/components/Image';
import AnimatedButton from '@/components/shared/AnimatedButton';
import { Typography } from '@/components/shared/Typography';

import css from './style.module.scss';

interface Props {
	title: string;
	text?: string;
	backLabel?: string;
	onClearFilters: () => void;
	className?: string;
}

const FilterEmptyResult: FC<Props> = ({
	title,
	text,
	backLabel = 'Back to all',
	onClearFilters,
	className
}) => (
	<div className={clsx(css.wrapper, className)}>
		<div className={css.content}>
			<Image
				className={css.image}
				src="/assets/images/filter-empty-result.webp"
				width={170}
				height={145}
				quality={100}
				alt={title}
			/>
			<div className={css.textWrapper}>
				<Typography variant="h5" tag="h2" className={css.title}>
					{title}
				</Typography>
				{text ? (
					<Typography variant="body-s" tag="p" className={css.text}>
						{text}
					</Typography>
				) : null}
			</div>
			<AnimatedButton className={css.button} onClick={onClearFilters}>
				{backLabel}
			</AnimatedButton>
		</div>
	</div>
);

export default FilterEmptyResult;
